// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const spacing = {
    4: "0.25rem",
    8: "0.5rem",
    16: "1rem",
    24: "1.5rem",
    32: "2rem",
    40: "2.5rem",
    48: "3rem",
    64: "4rem",
    80: "5rem",
    160: "10rem",
};
module.exports = spacing;
//# sourceMappingURL=spacing.js.map